import {Formik} from "formik";
import {Button, Col, Container, Form, FormGroup, InputGroup, Row, Spinner, Tab, Tabs} from "react-bootstrap";
import styles from "../usermanagement.module.css";
import {useNavigate} from "react-router";
import * as yup from "yup";
import {useContext, useEffect, useState} from "react";
import {BackendContext} from "../../../context/Backend";
import {useTranslation} from "react-i18next";
import {Eye, EyeSlash} from "react-bootstrap-icons";
import {useSubmit} from "react-router-dom";

export const NewForm = (props) => {

    const navigate = useNavigate();
    const backend = useContext(BackendContext);
    const [countryList,setCountryList] = useState([]);
    const [languageList,setLanguageList] = useState([]);
    const {t} = useTranslation();
    const [showPassword, setShowPassword] = useState(false);
    const submit = useSubmit();

    useEffect(()=>{
        setCountryList([<option key={"0"}>{t('system.dropdownSelect')}</option>,...backend.countries.map((val) => <option key={val.id} value={val.id}>{val.country}</option>)]);
    },[backend.countries])

    useEffect(()=>{
        setLanguageList([<option key={"0"}>{t('system.dropdownSelect')}</option>,...backend.languages.map((val) => <option key={val.id} value={val.id}>{val.language}</option>)]);
    },[backend.languages])

    const handleCancel = (e) => {
        navigate("/");
    }

    const toggleEye = (e) => {
        setShowPassword(!showPassword);
    }

    const schema = yup.object().shape(
        {
            tabBasic: yup.object().shape({
                    firstName: yup.string().required(),
                    lastName: yup.string().required(),
                    login: yup.string().required(),
                    email: yup.string().required().email(),
                    country: yup.number().required(),
                    language: yup.number().required(),
                    password: yup.string().required(" ").matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
                        t('password.policy')),
                passwordRepeated: yup.string()
                    .when("password",
                        {
                            is: (val) => val,
                            then: (schema) =>
                                schema.required()
                                    .oneOf([yup.ref('password')], 'Your passwords do not match.'),
                        })


                }
            )
        }
    );

    return (
        <Formik
            validationSchema={schema}
            initialValues={
                {
                    tabBasic:
                        {
                            firstName: '',
                            lastName: '',
                            login: '',
                            password: '',
                            language: '',
                            country: '',
                            passwordRepeated: '',
                            passwordPolicy: "default_password",
                        }
                }}
            onSubmit={(values, actions) => {
                const user = {
                    firstName: values.tabBasic.firstName,
                    lastName: values.tabBasic.lastName,
                    login: values.tabBasic.login,
                    passwordMode: values.tabBasic.passwordPolicy,
                    password: values.tabBasic.password,
                    countryId: values.tabBasic.country,
                    languageId: values.tabBasic.language,
                    email: values.tabBasic.email
                }
                backend.api.createUser(user, (resp) => {
                    submit(null, {method: "post", action: "/"})
                    navigate("/", {state: {message: t('system.createSuccessful')}});
                }, (error) => {
                    if (error.data?.message === "registration_email_taken_message") {
                        actions.setSubmitting(false);
                        actions.setFieldError("tabBasic.email", "registration_email_taken_message")
                    } else if (error.data?.message === "registration_login_taken_message") {
                        actions.setSubmitting(false);
                        actions.setFieldError("tabBasic.login", "registration_login_taken_message")
                    } else {
                        navigate("/error", backend.api.getErrorState(error));
                    }
                });
            }}>{({handleSubmit, handleChange, errors, values, isSubmitting, dirty, isValid}) => (
            <Form className={"p-0 " + styles.tabs} onSubmit={handleSubmit} autoComplete={"off"}>
                <Row>
                    <Tabs
                        defaultActiveKey="basic"
                        transition={true}
                        id="edit-tab"
                        className={"mb-0 bg-primary"}
                    >
                        <Tab eventKey="basic" title={t('profile.basic')}
                             tabClassName={!!errors.tabBasic ? ("text-danger") : null}>
                            <Container fluid={true} className={"py-4"}>
                                <Row>
                                    <Col>
                                        <div className={"inputContainer"}>
                                            <Form.Label htmlFor="tabBasic.firstName"
                                                        className={styles.label}>{t('profile.firstName')}</Form.Label>
                                            <Form.Control type="text" name={"tabBasic.firstName"}
                                                          onChange={handleChange}
                                                          value={values.tabBasic.firstName}
                                                          isInvalid={!!errors.tabBasic?.firstName}/>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className={"inputContainer"}>
                                            <Form.Label htmlFor="tabBasic.lastName"
                                                        className={styles.label}>{t('profile.lastName')}</Form.Label>
                                            <Form.Control type="text" name={"tabBasic.lastName"} onChange={handleChange}
                                                          value={values.tabBasic.lastName}
                                                          isInvalid={!!errors.tabBasic?.lastName}/>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className={"inputContainer"}>
                                            <Form.Label htmlFor="tabBasic.email"
                                                        className={styles.label}>{t('profile.email')}</Form.Label>
                                            <Form.Control type="text" name={"tabBasic.email"} onChange={handleChange}
                                                          value={values.tabBasic.email}
                                                          isInvalid={!!errors.tabBasic?.email}/>
                                            <Form.Control.Feedback
                                                type={"invalid"}
                                                className={"px-2"}>{errors.tabBasic?.email === "registration_email_taken_message" ? (t('profile.emailExists')) : ""}
                                            </Form.Control.Feedback>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className={"inputContainer"}>
                                            <Form.Label htmlFor="tabBasic.login"
                                                        className={styles.label}>{t('profile.login')}</Form.Label>
                                            <Form.Control type="text" name={"tabBasic.login"} onChange={handleChange}
                                                          value={values.tabBasic.login}
                                                          isInvalid={!!errors.tabBasic?.login}/>
                                            <Form.Control.Feedback
                                                type={"invalid"}
                                                className={"px-2"}>{errors.tabBasic?.login === "registration_login_taken_message" ? (t('profile.loginExists')) : ""}
                                            </Form.Control.Feedback>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className={"inputContainer"}>
                                            <Form.Label htmlFor="tabBasic.country"
                                                        className={styles.label}>{t('profile.country')}</Form.Label>
                                            <Form.Select
                                                name={"tabBasic.country"}
                                                value={values.tabBasic.country}
                                                onChange={handleChange}
                                                isInvalid={!!errors.tabBasic?.country}>
                                                {countryList}
                                            </Form.Select>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className={"inputContainer"}>
                                            <Form.Label htmlFor="tabBasic.language"
                                                        className={styles.label}>{t('profile.language')}</Form.Label>
                                            <Form.Select
                                                name={"tabBasic.language"}
                                                value={values.tabBasic.language}
                                                onChange={handleChange}
                                                isInvalid={!!errors.tabBasic?.language}>
                                                {languageList}
                                            </Form.Select>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className={"inputContainer"}>
                                            <Form.Label htmlFor="tabBasic.password"
                                                        className={styles.label}>password</Form.Label>
                                            <InputGroup>
                                                <Form.Control type={showPassword ? ("text") : ("password")}
                                                              name={"tabBasic.password"} onChange={handleChange}
                                                              value={values.tabBasic.password}
                                                              autoComplete={"new-password"}
                                                              isInvalid={!!errors.tabBasic?.password}/>
                                                <InputGroup.Text className={"bg-light border-0"}>{showPassword ?
                                                    <EyeSlash onClick={toggleEye}/> :
                                                    <Eye onClick={toggleEye}/>}</InputGroup.Text>
                                                <Form.Control.Feedback
                                                    type={"invalid"}>{errors.tabBasic?.password}</Form.Control.Feedback>
                                            </InputGroup>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className={"inputContainer"}>
                                            <Form.Label htmlFor="tabBasic.passwordRepeated" className={styles.label}>password
                                                repeated</Form.Label>
                                            <Form.Control type="password" name={"tabBasic.passwordRepeated"}
                                                          onChange={handleChange}
                                                          value={values.tabBasic.passwordRepeated}
                                                          autoComplete={"new-password"}
                                                          isInvalid={!!errors.tabBasic?.passwordRepeated}/>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Tab>
                    </Tabs>
                </Row>
                <Row>
                    <div className="d-flex gap-2 p-2 justify-content-center">
                        <Button className={"websobutton"} size={"sm"} variant={"danger"}
                                onClick={handleCancel}>{t('system.cancelButton')}</Button>
                        <Button className={"websobutton"} type={"submit"} disabled={isSubmitting || !dirty || !isValid}
                                size={"md"}>
                            {isSubmitting ? (<Spinner
                                className={"me-2"}
                                as="span"
                                animation="border"
                                size="sm"
                            />) : null}{t('system.saveButton')}</Button>
                    </div>
                </Row>
            </Form>
        )}</Formik>

    );}